module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/stores/5_797df01f5572df79b222b9aa271464ee.jpg";